import { USER_LOG } from "~/constants/userlog";
import { CopilotLog } from "~/pages/copilotMessage/types/copilotLogs";

export const insertUserLogsStorage = (logs: CopilotLog[]) => {
  localStorage.setItem(USER_LOG, JSON.stringify(logs));
};

export const getAndClearStoragedLogs = () => {
  const logs = localStorage.getItem(USER_LOG);
  localStorage.removeItem(USER_LOG);
  return logs ? JSON.parse(logs) : [];
};
